<template>
  <div class="">
    <div class="mb-5">
      <button v-if="!children && (comment.status == 1 || comment.status == 3)" @click="$emit('approve')" class="btn btn-info py-2 px-3 me-2"><i class="fa fa-check me-1" /> تایید</button>
      <button v-if="!children && (comment.status == 1 || comment.status == 2)" @click="$emit('ignore')" class="btn btn-danger py-2 px-3"><i class="fa fa-trash-alt me-1" /> رد</button>
    </div>
    <div class="message-container d-flex flex-column mb-4">
      <div class="align-items-center d-flex mb-4">
        <img class="rounded-circle" src="../../assets/images/users/default.png" width="60" height="60" />
        <!-- <img class="rounded-circle" v-if="comment.imageUrl !== '' && comment.imageUrl !== null" :src="comment.imageUrl" width="41" height="43" />
        <img class="rounded-circle" v-else src="../../assets/images/users/default.png" width="41" height="42" /> -->
        <div class="fs-5 ms-4">
          <div class="name fs-5">{{ comment.fullName }}</div>
          <div class="text-black-50 mt-1 fs-5">{{ TellMeWhen(comment.createdDate) }}</div>
        </div>
      </div>
      <div class="">
        <div class="message-content">
          <p>{{ comment.description }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'view-comment-container',
  props: {
    children: Boolean,
    comment: {
      type: Object,
      default: null,
    },
  },
  created: function () {
    this.data.comment = this.comment
  },
  mounted() {},
}
</script>

<style scoped lang="scss">
@import '../../design/custom/components/_comment.scss';

.btn-info {
  color: #556EE6;
  background: rgba(85, 110, 230, 0.2);
}
.btn-danger {
  color: #F46A6A;
  background: rgba(244, 106, 106, 0.2);
}

.hover-parent {
  position: relative;
}
.hover-child {
  position: absolute;
  top: -20px;
  width: 300px;
  word-wrap: break-word;
  right: 50%;
  transform: translateX(50%);
  text-align: center;
  background-color: rgb(235, 235, 235);
  padding: 10px;
  border-radius: 5px;
}
</style>
